import * as institutionSummaryActions from '../actions/institution-summary.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface InstitutionSummaryState {
    loading: boolean;
    loaded: boolean;
    error: any;

    totals: any;
}

const initialState: InstitutionSummaryState = {
    loading: false,
    loaded: false,
    error: null,

    totals: null
};

export const institutionSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case institutionSummaryActions.GET_INSTITUTION_SUMMARY_TOTALS:
            return {
                ...state,
                error: null,
                loading: true,
                loaded: state.loaded
            };
        case institutionSummaryActions.GET_INSTITUTION_SUMMARY_TOTALS_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                loaded: true,
                totals: action.payload
            };
        case institutionSummaryActions.GET_INSTITUTION_SUMMARY_TOTALS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case institutionSummaryActions.GET_INSTITUTION_SUMMARY_TOTALS:
            return {
                ...state,
                error: null,
                loading: false,
                loaded: false,
                totals: null
            };
        default:
            return state;
    }
};

export const getInstitutionSummaryState = createFeatureSelector<InstitutionSummaryState>('institutionSummaryReducer');

export const getBuildingFacilitiesAssessmentTotals = (state: InstitutionSummaryState) => state.totals;
export const getBuildingFacilitiesAssessmentTotalsLoaded = (state: InstitutionSummaryState) => state.loaded;
